<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <bubbles-background></bubbles-background>
        <div class="container container-xlg shape-container">
          <card shadow class="card-profile mb-4 mt-4 border-0" no-body>
            <vertical-ptwist-modules></vertical-ptwist-modules>

            <card-header title="Topic Modeling" :icon="{prefix:'fas', iconName: 'sitemap'}"
                         :text="pageText"></card-header>
            <div class="px-4 pb-3">
              <div class="mb-4">
                <collections-select :collection="collection" alternative label="Collections"></collections-select>
                <div v-if="topics">
                  <div class="row mt-4">
                    <div class="col-md-6 col-sm-12">
                      <topics :currentTopic.sync="currentTopic" :topics="topics"></topics>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <terms :topics="topics"></terms>
                    </div>
                    <!--<topic-modeling-charts :topics="topics"></topic-modeling-charts>-->
                  </div>
                </div>
                <ptwist-loading v-else-if="loading"></ptwist-loading>
                <server-error v-else-if="error"></server-error>
                <no-data-error v-else></no-data-error>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import { getInfoText } from '../info'
import { Bus } from '../bus'
import Topics from '@/components/TopicModeling/TopicModelingTopics'
import Terms from '@/components/TopicModeling/TopicModelingTerms'
import VerticalPtwistModules from '@/components/VerticalPtwistModules.vue'

export default {
  name: 'topic-modeling',
  components: { 'topics': Topics, 'terms': Terms, VerticalPtwistModules },
  data () {
    return {
      pageText: getInfoText('topicModeling'),
      loading: true,
      topics: null,
      error: false,
      currentTopic: {
        id: 1
      }
    }
  },
  watch: {
    collection () {
      this.updateTopics()
    }
  },
  created () {
    if (this.$route.query.collection) {
      this.collection = this.$route.query.collection
    } else {
      this.collection = 'plastic_pollution'
    }

    this.updateTopics()
    Bus.$on('new-collection', function (newCollection) {
      this.collection = newCollection
      this.updateTopics()
    }.bind(this))
  },
  methods: {
    changeCollection (collection) {
      this.collection = collection
      this.updateTopics()
    },
    updateTopics () {
      this.topics = null
      this.loading = true
      let payload = {
        data: {
          collection: this.collection
        },
        endpoint: 'plastictwist/topics'
      }
      this.$store
        .dispatch('api/get', payload)
        .then((response) => {
          this.topics = response.data.topics
        }).catch((error) => {
          console.error(error)
          this.error = true
        }).finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
